module.exports = __webpack_public_path__ + "static/nz_digital_wallet-apple-pay-phone-400b8c9a9df9c2b832994e2f86db9ca7.png";